import { render, staticRenderFns } from "./DefaultsByProduct.vue?vue&type=template&id=3cba2418&scoped=true&"
import script from "./DefaultsByProduct.vue?vue&type=script&lang=js&"
export * from "./DefaultsByProduct.vue?vue&type=script&lang=js&"
import style0 from "./DefaultsByProduct.vue?vue&type=style&index=0&id=3cba2418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cba2418",
  null
  
)

export default component.exports